import React, { useEffect } from "react";
import { CurrentConversationProvider } from "utilities/atoms/conversations/current-conversation/current-conversation-provider";
import { BookviewConversationAtom } from "utilities/atoms/conversations/current-conversation/conversation-atoms";
import { useHistory, useLocation } from "react-router";
import { useConversationActions } from "utilities/atoms/conversations/current-conversation/use-conversation-actions.hook";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import BookviewTabPanelFooter from "./bookview-tab-panel-footer";
import ChatPanelContent from "./chat-panel-content";
import { ChatContextType } from "constants/chat-context-types";
import useBookviewChatContext from "./use-bookview-chat-context";

const CONVERSATION_ID = "conversationId";

const BookviewChatPanelContent: React.FC = () => {
    const { loadConversation } = useConversationActions();
    const { search, pathname, hash } = useLocation();
    const history = useHistory();
    const { inMobileView } = useBreakpointRanges();
    useEffect(() => {
        const query = new URLSearchParams(search);
        const conversationId = query.get(CONVERSATION_ID);
        if (conversationId) {
            loadConversation(conversationId);

            query.delete(CONVERSATION_ID);
            history.replace({ pathname, search: query.toString(), hash });
        }
    }, [hash, history, loadConversation, pathname, search]);

    const { bookviewChatContext: context } = useBookviewChatContext();
    const contextList = [
        `NFPA ${context.code} (${context.edition})`,
        `${context.entityType ? `${context.entityType} ` : ""}${context.caapsNumber}`,
    ].filter((entry) => entry !== null);

    return (
        <>
            <ChatPanelContent
                context={ChatContextType.Bookview}
                contextList={contextList}
                applicationContext={context.applicationContext}
            />
            {!inMobileView && <BookviewTabPanelFooter />}
        </>
    );
};

// Wrap the content component with the provider so we can use the hook
const BookviewChatPanel: React.FC = () => (
    <CurrentConversationProvider atom={BookviewConversationAtom}>
        <BookviewChatPanelContent />
    </CurrentConversationProvider>
);

export default BookviewChatPanel;
